export default __webpack_public_path__ + "static/media/checkout-ad.f8da419e.png";